import { useQuery } from "@tanstack/react-query";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";
import { useWorkspace } from "./WorkspaceContext";

type EventRow = { id: string; type: string; issuanceId: string; emittedAt: string };

export function EventsTab() {
  const { campaignId } = useWorkspace();
  const { data } = useQuery({
    queryKey: ["workspace-events", campaignId],
    queryFn: () => api.get<{ items: EventRow[] }>(`/api/admin/campaigns/${campaignId}/events`),
  });
  const items = data?.items ?? [];

  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-head text-lg font-semibold">Events</h2>
        <p className="text-xs text-muted-foreground">Engagement events for this campaign's sends.</p>
      </div>
      <Card>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left border-b border-admin-rule">
              <th className="p-3 font-medium">Event</th>
              <th className="p-3 font-medium">When</th>
            </tr>
          </thead>
          <tbody>
            {items.map((e) => (
              <tr key={e.id} className="border-b border-admin-rule">
                <td className="p-3"><Badge variant="outline">{e.type.replace(/_/g, " ")}</Badge></td>
                <td className="p-3 text-muted-foreground">{new Date(e.emittedAt).toLocaleString()}</td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr>
                <td colSpan={2} className="p-6 text-center text-xs text-muted-foreground">
                  No events yet — they appear here as this campaign's sends are opened and watched.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
